'use strict';

const sbjs = require('sourcebuster');

sbjs.init();

const getOrNull = (value) => {
    if (typeof value !== 'undefined' && value !== '(none)') {
        return value;
    }
    return null;
};

const applyUtmParameters = (dimensions) => {
    if (!sbjs.get.current) {
        return dimensions;
    }

    const utmParams = {
        utmSource: 'src',
        utmMedium: 'mdm',
        utmCampaign: 'cmp',
        utmContent: 'cnt',
        utmTerm: 'trm'
    };

    Object.keys(utmParams).forEach(key => {
        dimensions[key] = getOrNull(sbjs.get.current[utmParams[key]]);
    });

    return dimensions;
};

const getOrigin = () => {
    let origin;

    if (sbjs.get.current && sbjs.get.current.typ) {
        origin = sbjs.get.current.typ;
    }

    switch (origin) {
        case 'organic':
            origin = 'ORGANIC';
            break;
        case 'referral':
            origin = 'REFERRAL';
            break;
        case 'typein':
            origin = 'DIRECT';
            break;
        case 'utm':
            origin = 'UTM';
            break;
        default:
            origin = 'DIRECT';
            break;
    }

    return origin;
};

const getReferer = () => {
    let referer = null;

    if (sbjs.get.current && sbjs.get.current_add && sbjs.get.current_add.rf) {
        if (sbjs.get.current_add.rf !== '(none)') {
            referer = sbjs.get.current_add.rf;
        }
    }

    return referer;
};

module.exports = {
    applyUtmParameters,
    getOrigin,
    getReferer
};
